export const baseUrl = "https://sisccltd.com/medialgeria/api/";
// export const baseUrl = "http://192.168.1.59:3200/api/"; //for local
